/**
 * @author Ewen
 * 通用函数
 */

var __EWEN_C = {
    getRatioVal: function ($name) {
        return $("input[name='" + $name + "']:checked").val();
    },
    getSelectText: function ($name) {
        return $("select[name='" + $name + "']").find("option:selected").text();
    },
    getSelectVal: function ($name) {
        var s = $("select[name='" + $name + "']").val();
        if (s == "" || s == undefined) {
            s = this.getSelectText($name)
        }
        return s;
    },
    getCheckboxVal: function ($name) {
        //js获取复选框值
        var obj = document.getElementsByName($name);
        var s = '';//如果这样定义var s;变量s中会默认被赋个null值
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].checked) //取到对象数组后，我们来循环检测它是不是被选中
                s += obj[i].value + ',';   //如果选中，将value添加到变量s中
        }
        return s;

        //jquery获取复选框值
        //var chk_value =[];//定义一个数组
        //$('input[name="'+$name+'"]:checked').each(function(){//遍历每一个名字为interest的复选框，其中选中的执行函数
        //    chk_value.push($(this).val());//将选中的值添加到数组chk_value中
        //});
        //return chk_value.join(",");
    },
    isMobile: {
        _ua: window.navigator.userAgent,
        Android: function () {
            return this._ua.match(/Android/i) ? true : false;
        },
        BlackBerry: function () {
            return this._ua.match(/BlackBerry/i) ? true : false;
        },
        iOS: function () {
            return this._ua.match(/iPhone|iPad|iPod/i) ? true : false;
        },
        Windows: function () {
            return this._ua.match(/IEMobile/i) ? true : false;
        },
        WeiXin: function () {
            return this._ua.match(/MicroMessenger/i) ? true : false;
        },
        any: function () {
            return (this.Android() || this.BlackBerry() || this.iOS() || this.Windows());
        }
    }
};
var EWEN_COMMON = __EWEN_C;
/**
 * @author Ewen
 * 全局参数设定和初始化
 */

__EWEN_C.getQueryString = function getQueryString($name, $url) {
    var tmp_url = $url ? $url.substr($url.indexOf("?")) : window.location.search;
    var reg = new RegExp("(^|&)" + $name + "=([^&]*)(&|$)");
    var r = tmp_url.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};


/**
 * 获得字符串实际长度，中文2，英文1
 * @param str：要获得长度的字符串
 */
__EWEN_C.strLen = function strLen(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
        }
        else {
            len += 2;
        }
    }
    return len;
}

/**
 * js截取字符串，中英文都能用
 * @param str：需要截取的字符串
 * @param len: 需要截取的长度
 *
 * console.log(strCut("JS~字符串长度判断，超出进行自动截取（支持中文）", 30));
 */
__EWEN_C.strCut = function strCut(str, len) {
    var str_length = 0;
    var str_len = 0;
    str_cut = new String();
    str_len = str.length;
    for (var i = 0; i < str_len; i++) {
        a = str.charAt(i);
        str_length++;
        if (escape(a).length > 4) {
            //中文字符的长度经编码之后大于4
            str_length++;
        }
        str_cut = str_cut.concat(a);
        if (str_length >= len) {
            str_cut = str_cut.concat("...");
            return str_cut;
        }
    }
    //如果给定字符串小于指定长度，则返回源字符串；
    if (str_length < len) {
        return str;
    }
};


__EWEN_C.fmtNum = function fmtNum(s, n) {
    n = n >= 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    var t = "";
    for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    var x = t.split("").reverse().join("");
    return n > 0 ? x + "." + r : x;
};


__EWEN_C.return2Br = function (str) {
    return str.replace(/\r?\n/g, "<br />");
};

//去掉html标签
__EWEN_C.removeHtmlTab = function (tab) {
    return tab.replace(/<[^<>]+?>/g, '');//删除所有HTML标签
};

//普通字符转换成转意符
__EWEN_C.html2Escape = function (sHtml) {
    return sHtml.replace(/[<>&"]/g, function (c) {
        return {'<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;'}[c];
    });
};

//转意符换成普通字符
__EWEN_C.escape2Html = function (str) {
    var arrEntities = {'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"'};
    return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
    });
};


function IETester(userAgent) {
    var UA = userAgent || navigator.userAgent;
    if (/msie/i.test(UA)) {
        return parseFloat(UA.match(/msie (\d+\.\d+)/i)[1]);
    } else if (~UA.toLowerCase().indexOf('trident') && ~UA.indexOf('rv')) {
        return parseFloat(UA.match(/rv:(\d+\.\d+)/)[1]);
    }
    return 999;
}

var os = (function () {
    var ua = navigator.userAgent;
    var obj = {
        name: ua,
        isIE67: /MSIE ([^;]+)/.test(ua),
        isIE7: !'1' [0],
        isIE8: !window.addEventListener,
        isIE9: !!window.addEventListener && !document.documentElement.classList,
        isIE8up: /Trident\/([\d\.]+)/.test(ua),
        isAndroid: /android/i.test(ua),
        isIOS: /iphone os/i.test(ua),
        isIpad: /ipad/i.test(ua),
        isWM: /windows ce/i.test(ua) || /windows mobile/i.test(ua),
        isMidp: /midp/i.test(ua),
        isUc7: /rv:1.2.3.4/i.test(ua),
        isUc: /ucweb|UCBrowser/i.test(ua),
        isWeiXin: /MicroMessenger/i.test(ua),
        isWebKit: /webkit/i.test(ua),
        isChrome: /Chrome/i.test(ua),
        isQQ: /MQQBrowser/i.test(ua),
        isFirefox: /rv:([^\)]+)\) Gecko\/\d{8}/.test(ua) && /Firefox\/(\S+)/.test(ua),
        isToutiao: /(News|NewsSocial|Explore|NewsArticle)( |\/)(\d.\d.\d)/i.test(ua),
        isHuawei: /HUAWEI/i.test(ua)
    };

    obj.isMobile = obj.isAndroid || obj.isIOS || obj.isIpad || obj.isWM || obj.isMidp || obj.isUc7 || obj.isUc;
    obj.isltIE9 = obj.isIE67 || obj.isIE8;
    obj.isPC = !(typeof window.orientation === 'number');
    // obj.isIE = obj.isPC && !obj.isWebKit && !obj.isChrome && !obj.isFirefox;
    obj.isIE = obj.isIE67 || obj.isIE8up;
    obj.isMac = /macintosh|mac os x/i.test(ua);
    return obj;
})();


window.requestAFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        function (callback) {
            return window.setTimeout(callback, 1000 / 30);
        };
})();
window.cancelAFrame = (function () {
    return window.cancelAnimationFrame ||
        window.webkitCancelAnimationFrame ||
        window.mozCancelAnimationFrame ||
        window.oCancelAnimationFrame ||
        function (id) {
            window.clearTimeout(id);
        };
})();

function showErr(id) {
    var errObjs = {
        "1": "ERROR MSG"
    };

    if (id.indexOf("::") >= 0) {
        id = id.substr(id.indexOf("::") + 3);
    }
    if (errObjs.hasOwnProperty(id)) {
        alert(errObjs[id]);
    }
}

/*
 * 时间格式化
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * (new Date()).format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @param format string 时间
 */
Date.prototype.format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt /*, from*/) {
        var len = this.length >>> 0;
        var from = Number(arguments[1]) || 0;
        from = (from < 0) ? Math.ceil(from) : Math.floor(from);
        if (from < 0)
            from += len;
        for (; from < len; from++) {
            if (from in this &&
                this[from] === elt)
                return from;
        }
        return -1;
    };
}
